/**
 * Get's the URL search params for a relative or absolute URL
 */
export const getURLSearchParams = (path: string) => {
    if (!path.includes('?')) {
        return new URLSearchParams();
    }
    const [, params] = path.split('?');
    return new URLSearchParams(params);
};
